import { render, staticRenderFns } from "./CauseOfDeath.vue?vue&type=template&id=9811c6d8"
import script from "./CauseOfDeath.vue?vue&type=script&lang=js"
export * from "./CauseOfDeath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports